import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import {CgBusyModule} from 'angular-busy2';
import 'rxjs/add/operator/map';

import { SharedModule, CustomMaterialModule } from '../shared/shared';

import { AuthService } from './auth.service';
import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth.component';
import { LogoutComponent } from "./logout/logout.component";
import { AuthGuard } from './auth.guard';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { extendedJwtProvider } from './http/jwthttp';

const authModuleRoutes: Routes = [
    {
        path: 'login', component: AuthComponent,
        children: [
            { path: '', component: LoginComponent }
        ]
    }
];

// Feature Module 'AuthModule'
@NgModule({
    imports: [
        CommonModule, // This is imported by Feature Modules 
        RouterModule.forChild(authModuleRoutes),
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        CgBusyModule,
        CustomMaterialModule,
        RecaptchaModule.forRoot(),
        RecaptchaFormsModule,
        NgProgressHttpModule
    ],
    providers: [
        extendedJwtProvider,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: '6LdPHzcUAAAAANkECOBtqLOGtFj5Y9rIgvQ8UFaf',
            } as RecaptchaSettings,
        },
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: 'de',
        }
    ],
    declarations: [
        AuthComponent,
        LoginComponent,
        LogoutComponent,
    ],
    exports: [AuthComponent, LogoutComponent],
    bootstrap: [AuthComponent]
})

export class AuthModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AuthModule,
            providers: [AuthGuard, AuthService, extendedJwtProvider]
        };
    }

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/_authentication/auth.module.ts